export const GTMVariablesPrefix = 'window.ipsy3';

export enum GTMVariables {
  GTM_EVENTS = 'GTM_EVENTS',
  SUBSCRIPTION_ID = 'subscriptionId',
  SUBSCRIPTION_COST = 'subscriptionCost',
  SUBSCRIPTION_CURRENCY = 'subscriptionCurrency',
  SUBSCRIPTION_PAYMENT_TYPE = 'paymentType',
  SUBSCRIPTION_CADENCE = 'subscriptionCadence',
  SUBSCRIPTION_PROGRAM = 'subscriptionProgram',
  USER_ID = 'userId',
  USER_SID = 'userSid',
  USER_EMAIL = 'userEmail',
  USER_PHONE = 'userPhone',
  USER_STATUS = 'userStatus',
  IS_COMING_FROM_SPA = 'isComingFromSpa',
  ENHANCED_CONVERSION_DATA = 'enhanced_conversion_data',
  ENHANCED_CONVERSION_DATA_EMAIL = 'email',
  CONVERSION_ID = 'conversionId',
}

export const getVariableName = (key: GTMVariables) =>
  `${GTMVariablesPrefix}.${key}`;
